import { EntityLabel } from "components/Shared/Labels/EntityLabel";
import type { PeopleTypes } from "enums/peopleTypes";
import { useSharedColumnBuilder } from "hooks/useSharedColumnBuilder";
import { useIntl } from "react-intl";

type Props = {
  type: PeopleTypes;
  onCopy: (record: any) => void;
  onPreview: (record: any) => void;
};

export const useCopyPeopleFixturesColumns = ({ type, onCopy, onPreview }: Props) => {
  const { formatMessage } = useIntl();
  const {
    createFixtureRoundColumn,
    createFixtureResultColumn,
    createFixtureStartDateColumn,
    createFixtureStartTimeColumn,
    createFixtureStatusColumn,
    createCopyPeopleActionsColumn,
  } = useSharedColumnBuilder();

  return [
    createFixtureRoundColumn(),
    {
      title: formatMessage({ id: "columns.fixture.homeEntity" }),
      dataIndex: "homeEntity",
      align: "right",
      render: (value) => <EntityLabel title={value?.nameLocal} imageUrl={value?.imageLogoUrl} />,
      width: 200,
    },
    createFixtureResultColumn(),
    {
      title: formatMessage({ id: "columns.fixture.awayEntity" }),
      dataIndex: "awayEntity",
      render: (value) => <EntityLabel title={value?.nameLocal} imageUrl={value?.imageLogoUrl} />,
      width: 200,
    },
    createFixtureStartDateColumn(),
    createFixtureStartTimeColumn(),
    createFixtureStatusColumn(),
    createCopyPeopleActionsColumn(type, onPreview, onCopy),
  ];
};
